import React from 'react';
import s from './solution-info.scss';
import { IconPreviewWrapper } from '../../preview-elements/icon-wrapper';
import type { IDetailsProps } from './solution-info-details';
import {
  SolutionInfoDetails,
  dtoToDetailsProps,
} from './solution-info-details';
import type { IPreviewProps } from './solution-info-preview';
import {
  SolutionInfoPreview,
  dtoToPreviewProps,
} from './solution-info-preview';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { getClientImageURL } from '../../../../common/getClientImageURL';
import { Avatar, Card } from '@wix/design-system';
import type { WebSolution } from '@wix/ambassador-marketplace/types';
import type { IAppDependenciesProps } from '../solution-page';

export interface ISolutionInfoProps extends Partial<WithTranslationProps> {
  icon: string;
  solutionDetailsProps: IDetailsProps;
  solutionPreviewProps: IPreviewProps;

  alt?: string;
  appDependencies?: IAppDependenciesProps;
}
export const dtoToInfoProps = (
  solutionDto: WebSolution,
  isNotAvailableToInstall: boolean,
  preventNewOrdersInstallation: boolean,
): ISolutionInfoProps => {
  return {
    icon: solutionDto.baseInfo.icon,
    solutionDetailsProps: dtoToDetailsProps({
      company: solutionDto?.company,
      baseInfo: solutionDto?.baseInfo,
      isNotAvailableToInstall,
      preventNewOrdersInstallation,
    }),
    solutionPreviewProps: dtoToPreviewProps(solutionDto),
    alt: solutionDto.baseInfo.name,
  };
};

export const SolutionInfo = (props: ISolutionInfoProps) => {
  return (
    <div
      className={s.infoLayout}
      data-main-appid={props.solutionDetailsProps.id}
    >
      <div className={s.solutionDetails}>
        <div className={s.avatar}>
          <Card>
            <IconPreviewWrapper size="62px" src={props.icon}>
              <Avatar
                shape="square"
                dataHook="solution-icon-avatar"
                className={s.iconAvatar}
                size="size60"
                imgProps={{
                  src: getClientImageURL(props.icon),
                  alt: `${props.alt} logo`,
                }}
              />
            </IconPreviewWrapper>
          </Card>
        </div>
        <Card>
          <SolutionInfoDetails
            {...props.solutionDetailsProps}
            appDependencies={props.appDependencies}
          />
        </Card>
      </div>
      <div className={s.solutionGallery}>
        <SolutionInfoPreview
          {...props.solutionPreviewProps}
          appName={props.solutionDetailsProps.name}
          t={props.t}
        />
      </div>
    </div>
  );
};
